import { MessageSquare, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { AttachmentPicker } from "@/components/Attachments";

export const ReplyComposer = ({
  ticket, canComment, canSendTemplate,
  comment, setComment, commentAttach, setCommentAttach,
  sending, onSubmit,
  sendToWhatsapp, setSendToWhatsapp,
  waWindow, onOpenWaTemplate,
}) => (
  <div className="pt-3 border-t border-slate-100 space-y-3">
    {waWindow && !waWindow.window_open && canSendTemplate && (
      <div
        className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2.5 text-xs flex items-start gap-2"
        data-testid="wa-window-closed-banner"
      >
        <MessageSquare className="w-3.5 h-3.5 mt-0.5 text-amber-700 shrink-0" />
        <div className="flex-1">
          <div className="font-medium text-amber-900">WhatsApp 24-hour window closed</div>
          <div className="text-amber-800 mt-0.5">
            Last customer inbound was {waWindow.hours_since_last_inbound != null ? `${Math.round(waWindow.hours_since_last_inbound)}h ago` : "over 24h ago"}.
            Free-form replies won't deliver — use a pre-approved template to re-engage.
          </div>
        </div>
        <Button
          size="sm" variant="outline"
          className="border-amber-300 text-amber-900 hover:bg-amber-100 shrink-0"
          onClick={onOpenWaTemplate}
          data-testid="open-wa-template-btn"
        >
          Send template
        </Button>
      </div>
    )}
    <Textarea
      data-testid="ticket-comment-input"
      placeholder="Reply to customer..."
      rows={3}
      value={comment}
      onChange={(e) => setComment(e.target.value)}
      disabled={!canComment}
    />
    {ticket.channel && ticket.channel.toLowerCase() === "whatsapp" && (
      <div className="flex items-center justify-between gap-2 text-xs">
        <div className="flex items-center gap-2">
          <Switch
            id="send-to-whatsapp"
            checked={sendToWhatsapp}
            onCheckedChange={setSendToWhatsapp}
            data-testid="send-to-whatsapp-toggle"
          />
          <Label htmlFor="send-to-whatsapp" className="text-slate-600">
            Also send this reply to the customer via WhatsApp
          </Label>
        </div>
        {canSendTemplate && (
          <Button
            size="sm" variant="ghost"
            className="text-emerald-700 hover:text-emerald-800 hover:bg-emerald-50 h-7 text-xs"
            onClick={onOpenWaTemplate}
            data-testid="send-wa-template-btn"
          >
            <MessageSquare className="w-3 h-3 mr-1" />Template
          </Button>
        )}
      </div>
    )}
    <div className="flex items-end justify-between gap-3">
      <AttachmentPicker value={commentAttach} onChange={setCommentAttach} compact />
      <Button
        onClick={onSubmit}
        disabled={(!comment.trim() && commentAttach.length === 0) || sending || !canComment}
        className="bg-indigo-600 hover:bg-indigo-700"
        data-testid="ticket-send-comment-btn"
      >
        <Send className="w-3.5 h-3.5 mr-1.5" />
        {sending ? "Sending..." : "Send reply"}
      </Button>
    </div>
  </div>
);
